module.exports = __webpack_public_path__ + "static/media/stilly2.32376278.JPG";